export { default as Arrow1 } from './Arrow1';
export { default as Arrow2 } from './Arrow2';
export { default as Arrow3 } from './Arrow3';
export { default as Arrow4 } from './Arrow4';
export { default as Arrow } from './Arrow';
export { default as Attach } from './Attach';
export { default as Block } from './Block';
export { default as Blocked } from './Blocked';
export { default as Call } from './Call';
export { default as Cash } from './Cash';
export { default as Close } from './Close';
export { default as Comment } from './Comment';
export { default as Delete } from './Delete';
export { default as Delivery } from './Delivery';
export { default as Discover } from './Discover';
export { default as EyeOff } from './EyeOff';
export { default as EyeOn } from './EyeOn';
export { default as Filter } from './Filter';
export { default as Gps } from './Gps';
export { default as Globe } from './Globe';
export { default as Guidelines } from './Guidelines';
export { default as Hide } from './Hide';
export { default as ImageIcon } from './Image';
export { default as ImageIcon2 } from './Image2';
export { default as Info } from './Info';
export { default as Language } from './Language';
export { default as Leave } from './Leave';
export { default as Like } from './Like';
export { default as Link } from './Link';
export { default as Location1 } from './Location1';
export { default as Location } from './Location';
export { default as Media } from './Media';
export { default as Menu } from './Menu';
export { default as Mute } from './Mute';
export { default as Notification } from './Notification';
export { default as Pickup } from './Pickup';
export { default as Plus } from './Plus';
export { default as Refresh } from './Refresh';
export { default as Report1 } from './Report1';
export { default as Report } from './Report';
export { default as Resend } from './Resend';
export { default as Send } from './Send';
export { default as Star } from './Star';
export { default as Store } from './Store';
export { default as Store2 } from './Store2';
export { default as Time } from './Time';
export { default as Unmute } from './Unmute';
export { default as Address } from './Address';
export { default as Cart } from './Cart';
export { default as Chat } from './Chat';
export { default as Edit } from './Edit';
export { default as GroupPic } from './GroupPic';
export { default as MemberCopy } from './MemberCopy';
export { default as Member } from './Member';
export { default as Minus } from './Minus';
export { default as More } from './More';
export { default as Neutral } from './Neutral';
export { default as Office } from './Office';
export { default as Pointer } from './Pointer';
export { default as Reaction } from './Reaction';
export { default as Search } from './Search';
export { default as UserMinus } from './UserMinus';
export { default as UserSignIn } from './UserSignIn';
export { default as Instagram } from './Instagram';
export { default as Twitter } from './Twiter';
export { default as FacebookFooter } from './FacebookFooter';
export { default as Facebook } from './Facebook';
export { default as MousePointer } from './MousePointer';
export { default as Play } from './Play';
export { default as ArrowLeft } from './ArrowLeft';
export { default as ArrowRight } from './ArrowRight';
export { default as Tick } from './Tick';
export { default as Check } from './Check';
export { default as Check1 } from './Check1';
export { default as Google } from './Google';
export { default as Order } from './Order';
export { default as VerifiedIcon } from './VerifiedIcon';
export { default as DeliveryMini } from './DeliveryMini';
export { default as CaretUp } from './CaretUp';
export { default as EmployeeIcon } from './EmployeeIcon';
export { default as UsersIcon } from './UsersIcon';
export { default as CitiesIcon } from './CitiesIcon';
export { default as TransactionIcon } from './TransactionIcon';
export { default as SubscriberIcon } from './SubscriberIcon';
export { default as FinanceIcon } from './FinanceIcon';
export { default as TrophyIcon } from './TrophyIcon';
export { default as PagesIcon } from './PagesIcon';
export { default as DashboardIcon } from './DashboardIcon';
export { default as BagIcon } from './BagIcon';
export { default as CogSixTooth } from './CogSixTooth';
export { default as BackofficeLogo } from './BackofficeLogo';
export { default as ChevronDownIcon } from './ChevronDownIcon';
export { default as Bars3Icon } from './Bars3Icon';
export { default as BellIcon } from './BellIcon';
export { default as AdditivesIcon } from './AdditivesIcon';
export { default as CouponIcon } from './CouponIcon';
export { default as PushNotifyIcon } from './PushNotifyIcon';
export { default as ShareIcon } from './ShareIcon';
export { default as BriefCaseIcon } from './BriefCaseIcon';
export { default as InfoIcon } from './InfoIcon';
export { default as CalenderIcon } from './CalenderIcon';
export { default as ImportIcon } from './ImportIcon';
export { default as MoveIcon } from './MoveIcon';
export { default as UpChevronIcon } from './UpChevronIcon';
export { default as UploadIcon } from './UploadIcon';
export { default as Payment } from './Payment';
export { default as EllipsisVerticalIcon } from './EllipsisVerticalIcon';
export { default as Cross2Icon } from './Cross2Icon';
export { default as CubeIcon } from './CubeIcon';
export { default as ChevronUpDownIcon } from './ChevronUpDownIcon';
export { default as ExclamationCircleIcon } from './ExclamationCircleIcon';
export { default as FileIcon } from './FileIcon';
export { default as FilterIcon } from './FilterIcon';
export { default as ExportIcon } from './ExportIcon';
export { default as Linkedin } from './Linkedin';
export { default as YoutubeFooter } from './YoutubeFooter';
export { default as CheckMarkIcon } from './CheckMarkIcon';
export { default as ArrowDownUpIcon } from './ArrowDownUpIcon';
export { default as ReorderIcon } from './ReorderIcon';
export { default as CircleCloseIcon } from './CircleCloseIcon';
export { default as AppleIcon } from './AppleIcon';
